import React from 'react';
import { IconPath, Image } from 'cw-ui-core';
import css from './ConditionsList.scss';

// Since this is a generic component, it would be difficult without enforcing a column and row id
/* eslint react/no-array-index-key:0 */
const ConditionsList = props => {
    const getList = () => {
        if (props.conditions == null) {
            return null;
        }
        return props.conditions.map((condition, index) => (
            <div className={css.wrapListItem} key={`conditions${index}`}>
                <div className={css.prefix}>
                    {condition.validation(props.args) ? (
                        <Image src={IconPath.get('Status_Success')} style={{ fill: '#88D621' }} />
                    ) : (
                        '•'
                    )}
                </div>
                <span className={css.label}>{condition.text}</span>
            </div>
        ));
    };

    return <div className={css.wrap}>{getList()}</div>;
};

export default ConditionsList;
